<template>
  <div
    id="licenseproduct-list"
    v-infinite-scroll="getMoreItems"
    infinite-scroll-disabled="busy"
    infinite-scroll-distance="10"
    infinite-scroll-immediate-check="false"
    :class="outerPadding"
  >
    <list
      model-name="licensedproducts"
      :items-url="URL"
      :params="params"
      :flex-class="'pa-3'"
      :list-break-point="licenceBreakpoint"
      :empty-mark-enable="true"
    >
      <template slot-scope="props">
        <h3>{{ props.item.name }}</h3>
        <div class="mt-1">
          {{ props.item.category.name }} ({{ $t("variables.onlyEnglishAge") }}{{ props.item.age }})<br>
          {{ $t("variables.manufacturer") }}: {{ props.item.manufacturer }}<br>
          <div v-if="isEnglish()">
            Territory: {{ props.item.territory }}
          </div>
          <v-btn
            style="margin: 20px 0 0 0; width: 100%; text-transform: inherit;"
            @click.stop="linkTo(getDetailUrl(props.item))"
          >
            {{ $t("variables.viewDetail") }}
          </v-btn>
        </div>
      </template>
    </list>
  </div>
</template>

<script>
import infiniteScroll from 'vue-infinite-scroll'
import List from 'components/List.vue'

export default {
  directives: { infiniteScroll },
  components: {
    'list': List
  },
  data () {
    return {
      URL: '/api/products/licensedproducts/',
      items: [],
      nextLink: ''
    }
  },
  computed: {
    licenceBreakpoint () {
      return {
        'xs': 12,
        'sm': 6,
        'md': 4,
        'lg': 3,
        'xl': 3
      }
    },
    params () {
      return { category: this.$route.params.category }
    },
    padding () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
        case 'md': return 'pa-3'
        default: return 'pa-2'
      }
    },
    outerPadding () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
        case 'md': return 'px-4'
        default: return ''
      }
    }
  },
  watch: {
    '$route.params' () {
      // this.getInitialItems()
    },
    '$vuetify.breakpoint.name' (bp) {
    }
  },
  beforeMount () {
    // this.getInitialItems()
  },
  methods: {
    // getInitialItems () {
    //   this.params.lang = this.$language.locale
    //   this.$http.get(this.URL, { params: this.params })
    //     .then(response => {
    //       if (response.request.responseURL === this.URL) {
    //         this.items = response.data.results
    //         this.nextLink = response.data.next
    //       }
    //     })
    // },
    getMoreItems () {
      if (this.nextLink === null || this.nextLink === undefined) {
        return
      }
      this.busy = true
      this.$http.get(this.nextLink)
        .then(response => {
          if (response.request.responseURL === this.nextLink) {
            this.items = this.items.concat(response.data.results)
            this.nextLink = response.data.next
            this.busy = false
          }
          this.busy = false
        })
    },
    getDetailUrl (item) {
      let category = this.$route.params.category ? this.$route.params.category : 'all'
      return '/' + this.$language.locale + '/licensedproducts/' + category + '/' + item.code
    },
    linkTo (address) {
      this.$router.push(address)
    }
  }
}
</script>

<style>
#selected-products-empty{
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 80px;
  flex-direction: column;
}

#selected-products-empty #selected-products-empty-title{
  padding-top: 30px;
  margin: 0px;
  font-size: 24px;
  color: rgba(146, 146, 146, 0.9)
}
</style>



// WEBPACK FOOTER //
// src/app/contents/LicenseProductList.vue